import NotesOutput from "../shared/Notes/NotesOutput";
import { INote, ResourceType } from "../../models/Note";
import { IAccount } from "../../models/account/IAccount";

interface AccountNotesProps {
  notes: INote[];
  account: IAccount;
}

export default function AccountNotes({ notes, account }: AccountNotesProps) {
  return (
    <div className="pb-4">
      <NotesOutput
        resourceId={account.id}
        resourceType={ResourceType.Account}
        shouldScroll={false}
        notes={notes}
        refetchQuery={["accounts", account.id]}
      />
    </div>
  );
}
